import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { TranslocoModule } from '@jsverse/transloco';
import { CypressDirectiveModule } from '@shared/directives/cypress/cypress-directive.module';
import { QuestionnaireShareDialogComponent } from './questionnaire-share-dialog/questionnaire-share-dialog.component';
import { ButtonModule } from '@shared/components/atoms/button/button.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TooltipDirectiveModule } from '@shared/directives/tooltip/tooltip-directive.module';
import { CurQuestionnaireRendererInitService } from '@features/questionnaire-renderer/cur-questionnaire-renderer-init.service';
import { QuestionnaireRendererInitService } from '@xt/questionnaire-cdk';
import { MatDialogModule } from '@angular/material/dialog';
import { XtDialogComponent } from '@xt/ui-kit';
import { QuestionnaireShareConfirmationDialogComponent } from '@features/questionnaire-renderer/questionnaire-share-confirmation-dialog/questionnaire-share-confirmation-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CommonModule,
    ButtonModule,
    MatIconModule,
    TranslocoModule,
    CypressDirectiveModule,
    MatProgressBarModule,
    TooltipDirectiveModule,
    MatDialogModule,
    XtDialogComponent,
    QuestionnaireShareDialogComponent,
    QuestionnaireShareConfirmationDialogComponent,
  ],
  exports: [QuestionnaireShareDialogComponent],
  providers: [
    {
      provide: QuestionnaireRendererInitService,
      useExisting: CurQuestionnaireRendererInitService,
    },
  ],
})
export class QuestionnaireRendererModule {}
